import { TAB_INDEX } from '../Model/Model';
import FaceValidation from '../FaceValidation';
import FacePhoto from '../../../../../components/PhotoPicker/SubComponent/PhotoWebcam/FacePhoto';
import SubmittingIdCard from '../SubmittingIdCard';
import React from 'react';
import PassportCardVerification from '../PassportCardVerification';
import PassportCardPhoto from '../PassportCardPhoto';
import { FILE_TYPE_MODEL } from '../../Visitor/Model/Model';
import {SUGGESTION_MODE_OPTION} from "../../../../../components/PhotoPicker/SubComponent/Models/Models";

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const Steps = (
    {
        guardFlowId,
        activeStep,
        setActiveStep,

        facePhoto, setFacePhoto,
        passport, setPassport,
        idCardFront, setIdCardFront,
        idCardBack, setIdCardBack,

        handleSaveFaceValidation,
        handleSavePassport,
        handleSaveCardId,

        t,
        type,
        loading,
        nextPhoto,
        startup, setStartup,
        reopenSuggestionShow,
        setReopenSuggestionShow,

        handleCancelStreamCardId,
        handleCancelStreamPassport,
        handleCancelStreamSelfie
    }
) => {

    const renderFaceSteps = () => {
        switch (activeStep) {
            case TAB_INDEX.ONE:
                return <FaceValidation guardFlowId={guardFlowId} />;
            case TAB_INDEX.TWO:
                return (
                    <FacePhoto
                        photoPickerFile={facePhoto}
                        setPhotoPickerFile={setFacePhoto}
                        setActiveStep={setActiveStep}
                        startup={startup}
                        setStartup={setStartup}
                        handleCancelStream={handleCancelStreamSelfie}
                        guardFlowId={guardFlowId}
                        titleWebcam="make_sure_your_face_is_fully_visible_and_centered_in_the_frame"
                        titlePreviewWebcam="is_your_face_centered_and_clearly_visible"
                    />
                );
            case TAB_INDEX.THREE:
                return ( getSubmittingCard( FILE_TYPE_MODEL.SELFIE.id, handleSaveFaceValidation));
            default:
                return null;
        }
    };

    const renderFilesSteps = () => {
        switch (activeStep) {
            case TAB_INDEX.ONE:
                return <PassportCardVerification guardFlowId={guardFlowId}/>;
            case TAB_INDEX.TWO:
                return (
                    <PassportCardPhoto
                        nextPhoto={nextPhoto}
                        setActiveStep={setActiveStep}
                        passport={passport}
                        setPassport={setPassport}
                        idCardBack={idCardBack}
                        setIdCardBack={setIdCardBack}
                        idCardFront={idCardFront}
                        setIdCardFront={setIdCardFront}
                        startup={startup}
                        setStartup={setStartup}
                        reopenSuggestionShow={reopenSuggestionShow}
                        setReopenSuggestionShow={setReopenSuggestionShow}
                        type={type}
                        handleCancelStreamCardId={handleCancelStreamCardId}
                        handleCancelStreamPassport={handleCancelStreamPassport}
                        typeSuggestions={getTypeSuggestions()}
                    />
                );
            case TAB_INDEX.THREE:
                return ( getSubmittingCard( FILE_TYPE_MODEL.INE.id, () => {
                    if(type === FILE_TYPE_MODEL.PASSPORT.id) handleSavePassport();
                    else handleSaveCardId() ;
                }));
            default:
                return null;
        }
    };

    const renderCompleteSteps = () => {
        switch (activeStep) {
            case TAB_INDEX.ONE:
                return <PassportCardVerification guardFlowId={guardFlowId}/>;
            case TAB_INDEX.TWO:
                return (
                    <PassportCardPhoto
                        nextPhoto={nextPhoto}
                        setActiveStep={setActiveStep}
                        passport={passport}
                        setPassport={setPassport}
                        idCardBack={idCardBack}
                        setIdCardBack={setIdCardBack}
                        idCardFront={idCardFront}
                        setIdCardFront={setIdCardFront}
                        startup={startup}
                        setStartup={setStartup}
                        reopenSuggestionShow={reopenSuggestionShow}
                        setReopenSuggestionShow={setReopenSuggestionShow}
                        type={type}
                        handleCancelStreamCardId={handleCancelStreamCardId}
                        handleCancelStreamPassport={handleCancelStreamPassport}
                        typeSuggestions={getTypeSuggestions()}
                    />
                );
            case TAB_INDEX.THREE:
                return ( getSubmittingCard( FILE_TYPE_MODEL.PASSPORT.id, () => {
                    if(type === FILE_TYPE_MODEL.PASSPORT.id) handleSavePassport();
                    else handleSaveCardId() ;
                }));
            case TAB_INDEX.FOUR:
                return <FaceValidation guardFlowId={guardFlowId} />;
            case TAB_INDEX.FIVE:
                return (
                    <FacePhoto
                        photoPickerFile={facePhoto}
                        setPhotoPickerFile={setFacePhoto}
                        setActiveStep={setActiveStep}
                        startup={startup}
                        setStartup={setStartup}
                        handleCancelStream={handleCancelStreamSelfie}
                        guardFlow={guardFlowId}
                        titleWebcam="make_sure_your_face_is_fully_visible_and_centered_in_the_frame"
                        titlePreviewWebcam="is_your_face_centered_and_clearly_visible"
                    />
                );
            case TAB_INDEX.SIX:
                return ( getSubmittingCard( FILE_TYPE_MODEL.SELFIE.id, handleSaveFaceValidation ));
            default:
                return null;
        }
    };

    const getTypeSuggestions = () => {
        return type == FILE_TYPE_MODEL.PASSPORT.id ? SUGGESTION_MODE_OPTION.PASSPORT({guardFlowId}): SUGGESTION_MODE_OPTION.CARD({guardFlowId});
    }

    const getSubmittingCard = (type, handle) => {
        let title = '';
        let subtitle = '';

        if(type === FILE_TYPE_MODEL.INE.id || type === FILE_TYPE_MODEL.PASSPORT.id){
            if(guardFlowId){
                if(type === FILE_TYPE_MODEL.INE.id) title =  'thank_you_for_submitting_visitors_id';
                else title =  'thank_you_for_submitting_visitors_passport';

                subtitle =  'the_document_was_submitted_successfully_its_now_under_review';
            }else{
                title =  'thank_you_for_submitting_your_id_card';
                subtitle =  'thank_you_for_submitting_your_id_card_subtitle';
            }
        }else if(type === FILE_TYPE_MODEL.SELFIE.id){
            if(guardFlowId){
                title = 'thank_you_for_submitting_visitors_photo';
                subtitle = 'the_photo_has_been_submitted_successfully';
            }else{
                title = 'thank_you_for_submitting_your_photo';
                subtitle = 'thank_you_for_submitting_your_photo_subtitle';
            }
        }

        return <SubmittingIdCard
            title={t(title)}
            subtitle={t(subtitle)}
            handleSave={handle}
            loading={loading}
        />
    }

    return {
        renderFaceSteps, renderFilesSteps, renderCompleteSteps
    }

}

export default Steps
